module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pzLhcB/tc-custom/9781611522495.jpg?1721057661774",
      "alt": "This image is the cover for the book Optimism Made Simple"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Optimism Made Simple\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This is a short anthology of five true, inspirational stories which illustrate the amazing power of optimism."), _c('br'), _c('br'), _vm._v("Read about an airport shuttle driver who inexplicably waits past his midnight deadline for the author’s family. Find out what happens to a farmer who demands payment for hay he made but was given for free, or the stable manager who demands high payment from a rider to replace fence boards and posts the rider’s horses didn’t break. Meet a young man cured of Bell’s Palsy through prayer, or the unhappy woman who helps pay for a young relative’s college tuition after the author prays for her well-being."), _c('br'), _c('br'), _vm._v("Coupled with forgiveness and charitable thinking towards those who wish us evil, positive thoughts can resolve the toughest of situations to produce a happy result.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Hilary Walker\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0